<template>
  <Bar v-if="chartData" :data="chartData" :options="options" />
</template>

<script>
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
} from 'chart.js'
import { Bar } from 'vue-chartjs'
import getOptionsAndData from './chart_config/bar_categorization_options.js'

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

export default {
  name: 'ChartBar',
  components: {
    Bar,
  },
  props: {
    idEnterprise: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chartData: null,
      options: null,
    }
  },
  async mounted() {
    try {
      const { chartData, options } = await getOptionsAndData(this.idEnterprise)
      this.chartData = chartData
      this.options = options
    } catch (error) {
      console.error('Erro ao carregar dados do gráfico:', error)
    }
  },
}
</script>
